import React from "react";
import {withTranslation} from "react-i18next";
import ValidationHelper from "../../helpers/ValidationHelper";
import CamplaCoreService from "../../services/CamplaCoreService";
import {Button, Col, Container, Image, Row} from "react-bootstrap";
import PaginationTable from "../../components/paginationTable/PaginationTable";
import {textFilter} from "react-bootstrap-table2-filter";
import PaginationTableFilterToggle from "../../components/paginationTableFilterToggle/PaginationTableFilterToggle";
import StorageService from "../../services/StorageService";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import RunningDownloadDialog from "../../components/dialogs/runningDownloadDialog/RunningDownloadDialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleNotch, faEye} from "@fortawesome/free-solid-svg-icons";
import CamplaLernstickBridgeService from "../../services/CamplaLernstickBridgeService";


class ExaminationAccessFiles extends React.Component {
    constructor(props) {
        super(props);
        this.tableId = ["examinationAccessFilesExamination", "examinationAccessFilesStudent"];
        let showFilters1 = StorageService.tableConfigShowFilters(this.tableId[0]);
        let showFilters2 = StorageService.tableConfigShowFilters(this.tableId[1]);
        this.currentInstanceId = null;
        this.state = {
            studentFiles: [],
            examinationFiles: [],
            showFilters1,
            showFilters2,
            displayFilter1: showFilters1 ? "initial" : "none",
            displayFilter2: showFilters2 ? "initial" : "none",
            runningDownloadDialogShow: false,
            runningDownloadDialogTitle: "",
            runningDownloadDialogProgress: 0,
            isLernstickOnly: false,
            examinationUrl: null,
            examinationName: null,
            apiError: null,
            dialogApiError: null
        }

        this.humanReadableFileSize = this.humanReadableFileSize.bind(this);
        this.loadData = this.loadData.bind(this);
    }


    async componentDidMount() {
        this.currentInstanceId = StorageService.getPrimitive("currentInstanceId", true);
        if (typeof this.props["match"] !== "undefined"
            && typeof this.props.match["params"] !== "undefined"
            && typeof this.props.match.params["id"] !== "undefined"
            && ValidationHelper.isID(this.props.match.params.id)
        ) {
            this.currentInstanceId = this.props.match.params.id;
            StorageService.set("currentInstanceId", this.props.match.params.id, undefined, true);
        }

        if (this.currentInstanceId !== null) await this.loadData(this.currentInstanceId);
    }

    async openFile(file){
        if (this.currentInstanceId === null) return;
        try {
            const source = file.isExaminationFile === null ? "examination" : "student";
            let downloadURL;
            if (typeof window["CAMPLA"] === "undefined"
                && typeof window["SafeExamBrowser"] !== "undefined"
                && typeof window["SafeExamBrowser"]["security"] !== "undefined"
                && typeof window["SafeExamBrowser"].security["browserExamKey"] !== "undefined") {
                // Update security hashes
                if (typeof window["SafeExamBrowser"].security["update"] !== "undefined") {
                    await new Promise((resolve) => window.SafeExamBrowser.security.update(resolve));
                }
                downloadURL =  await CamplaCoreService.getInstanceFileDownloadURL(
                    this.props.match.params["id"],
                    file._id,
                    source,
                    window.SafeExamBrowser.security.browserExamKey);
            }else{
                downloadURL =  await CamplaCoreService.getInstanceFileDownloadURL(
                    this.props.match.params["id"],
                    file._id,
                    source);
            }
            const docId = crypto.randomUUID();
            localStorage.setItem(`camplaPDFURL_${docId}`, downloadURL);
            localStorage.setItem(`camplaPDFName_${docId}`, file.name);
            window.open(`/external/embedpdf/viewer.html?docId=${docId}`, "_blank");
        }catch (err){
            const { t } = this.props;
            this.setState({
                runningDownloadDialogShow: false,
                runningDownloadDialogTitle: "",
                runningDownloadDialogProgress: 0,
                dialogApiError: APIErrorHelper.getError(
                    err,
                    () => this.setState({ dialogApiError: "" }),
                    {
                        PRECONDITION_FAILED: "ExaminationAccessFiles.APIError.PreconditionFailed",
                        NOT_FOUND: "ExaminationAccessFiles.APIError.NotFound",
                        FORBIDDEN: "ExaminationAccessFiles.APIError.Forbidden"
                    },
                    t,
                ),
            });
        }
    }

    humanReadableFileSize(size) {
        const labels = ["B", "KB", "MB", "GB"];
        let ct = 0;
        while (size > 1024 && ct < labels.length) {
            size /= 1024;
            ct++;
        }
        return `${Math.round(size * 100) / 100} ${labels[ct]}`;
    }

    async loadData(instanceId) {
        let files;
        try {
            if (typeof window["CAMPLA"] === "undefined"
            && typeof window["SafeExamBrowser"] !== "undefined"
            && typeof window["SafeExamBrowser"]["security"] !== "undefined"
            && typeof window["SafeExamBrowser"].security["browserExamKey"] !== "undefined") {
                // Update security hashes
                if (typeof window["SafeExamBrowser"].security["update"] !== "undefined") {
                    await new Promise((resolve) => window.SafeExamBrowser.security.update(resolve));
                }
                files = await CamplaCoreService.getAllInstanceFiles(instanceId, window.SafeExamBrowser.security.browserExamKey);
            }else{
                files = await CamplaCoreService.getAllInstanceFiles(instanceId);
            }
            const examinationFiles = files.examinationFiles.map(ef => ({...ef, isExaminationFile: null}));
            files.studentFiles
                .filter(sf => sf.isExaminationFile)
                .forEach(sf => examinationFiles.push(sf));
            const studentFiles = files.studentFiles.filter(sf => !sf.isExaminationFile)
            const isLernstickOnly = CamplaLernstickBridgeService.getInstance().hasCAMPLAAddon() &&
                files.examination.securityLevel !== 5 && files.examination.securityLevel !== 6;
            this.setState({
                examinationUrl: files.examination.configuration.web_url,
                examinationName: files.examination.name,
                isLernstickOnly,
                examinationFiles,
                studentFiles
            });
        }catch (err){
            const { t } = this.props;
            this.setState({
                apiError: APIErrorHelper.getError(
                    err,
                    () => this.setState({ apiError: "" }),
                    {
                        PRECONDITION_FAILED: "ExaminationAccessFiles.APIError.PreconditionFailed",
                        NOT_FOUND: "ExaminationAccessFiles.APIError.NotFound",
                        FORBIDDEN: "ExaminationAccessFiles.APIError.Forbidden"
                    },
                    t
                ),
            });
        }
    }

    render() {
        const { t } = this.props;
        const columnExaminationFiles = [
            {
                dataField: "name",
                text: t("ExaminationAccessFiles.ColumnFilename"),
                sort: true,
                filter: textFilter({
                    placeholder: t(
                        "ExaminationAccessFiles.FilterFilenamePlaceholder",
                    ),
                    style: { display: this.state.displayFilter1 },
                })
            },
            {
                dataField: "size",
                text: t("ExaminationAccessFiles.ColumnSize"),
                sort: true,
                formatter: (size) => (this.humanReadableFileSize(size)),
            },
            {
                dataField: "actions",
                text: "",
                headerFormatter: () => (
                    <PaginationTableFilterToggle
                        onFilterToggle={(e) => {
                            this.setState({
                                showFilters1: e.currentTarget.checked,
                                displayFilter1: e.currentTarget.checked ? "initial" : "none",
                            });
                        }}
                        showFilters={this.state.showFilters1}
                        tableId={this.tableId[0]} />
                ),
                headerClasses: "actionHeader",
                isDummyField: true,
                csvExport: false,
                formatter: (cell, file) => (
                    <Row style={{ display: "block" }}>
                        <div className="floatRight">
                            <Button
                                className="btn btn-sm btn-green"
                                onClick={() => this.openFile(file)}
                            >
                                <FontAwesomeIcon icon={faEye} />
                            </Button>
                        </div>
                    </Row>
                )
            },
        ];
        const columnStudentFiles = [
            {
                dataField: "name",
                text: t("ExaminationAccessFiles.ColumnFilename"),
                sort: true,
                filter: textFilter({
                    placeholder: t(
                        "ExaminationAccessFiles.FilterFilenamePlaceholder",
                    ),
                    style: { display: this.state.displayFilter2 },
                })
            },
            {
                dataField: "size",
                text: t("ExaminationAccessFiles.ColumnSize"),
                sort: true,
                formatter: (size) => (this.humanReadableFileSize(size))
            },
            {
                dataField: "actions",
                text: "",
                headerFormatter: () => (
                    <PaginationTableFilterToggle
                        onFilterToggle={(e) => {
                            this.setState({
                                showFilters2: e.currentTarget.checked,
                                displayFilter2: e.currentTarget.checked ? "initial" : "none",
                            });
                        }}
                        showFilters={this.state.showFilters2}
                        tableId={this.tableId[1]} />
                ),
                headerClasses: "actionHeader",
                isDummyField: true,
                csvExport: false,
                formatter: (cell, file) => (
                    <Row style={{ display: "block" }}>
                        <div className="floatRight">
                            <Button
                                className="btn btn-sm btn-green"
                                onClick={() => this.openFile(file)}
                            >
                                <FontAwesomeIcon icon={faEye} />
                            </Button>
                        </div>
                    </Row>
                )
            },
        ];
        return (
            <>
                <RunningDownloadDialog
                    show={this.state.runningDownloadDialogShow}
                    onHide={() => this.setState({ runningDownloadDialogShow: false })}
                    title={this.state.runningDownloadDialogTitle}
                    progress={this.state.runningDownloadDialogProgress}
                    dialogApiError={this.state.dialogApiError}
                />
                <Container className="mt-3">
                    <Row className="pageTitle">
                        <Col>
                            <h2>{t("ExaminationAccessFiles.Title")}: {
                                this.state.examinationName ? this.state.examinationName : (
                                    <FontAwesomeIcon icon={faCircleNotch} spin />
                                )
                            }</h2>
                        </Col>
                    </Row>
                    {this.state.apiError ? (
                        <Row>
                            <Col>{this.state.apiError}</Col>
                        </Row>
                    ) : (
                        ""
                    )}
                    {this.state.examinationUrl ? (
                        <Row>
                            <Col>
                                <a href={this.state.examinationUrl} target="_blank">
                                    <Button className="btn btn-green">
                                        {t("ExaminationAccessFiles.OpenExaminationButton")}
                                    </Button>
                                </a>
                            </Col>
                        </Row>
                    ) : (<FontAwesomeIcon icon={faCircleNotch} spin />)}
                    {this.state.isLernstickOnly ? (
                        <>
                            <hr />
                            <Row className="mt-4">
                                <Col>
                                    <Image src="/images/examinationAccessFiles/lernstick-files.png" style={{width:'100%'}}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <ol>
                                        <li>{t("ExaminationAccessFiles.LernstickFilesInstrcution1")}</li>
                                        <li>{t("ExaminationAccessFiles.LernstickFilesInstrcution2")}
                                            <ul>
                                                <li><b>Abgabe_Submission:</b> {t("ExaminationAccessFiles.LernstickFilesInstrcution3")} <b>{t("ExaminationAccessFiles.LernstickFilesInstrcution4")}</b></li>
                                                <li><b>Unterlagen_Documents:</b> {t("ExaminationAccessFiles.LernstickFilesInstrcution5")}</li>
                                                <li><b>MeineUnterlagen_MyDocuments:</b> {t("ExaminationAccessFiles.LernstickFilesInstrcution6")}</li>
                                            </ul>
                                        </li>
                                        <li>{t("ExaminationAccessFiles.LernstickFilesInstrcution7")}</li>
                                    </ol>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <>
                            <hr />
                            <Row className="mt-4">
                                <Col>
                                    <h3>{t("ExaminationAccessFiles.ExaminationTableTitle")}</h3>
                                </Col>
                            </Row>
                            <Row className="mt-1 pb-3">
                                <Col>
                                    <PaginationTable
                                        data={this.state.examinationFiles}
                                        sizePerPage={100}
                                        paginationSize={3}
                                        columns={columnExaminationFiles}
                                        keyField="_id"
                                        noDataFoundLabel={t("ExaminationAccessFiles.NoExaminationFilesFound")}
                                        id={this.tableId[0]}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <h3>{t("ExaminationAccessFiles.StudentTableTitle")}</h3>
                                </Col>
                            </Row>
                            <Row className="mt-1 pb-3">
                                <Col>
                                    <PaginationTable
                                        data={this.state.studentFiles}
                                        sizePerPage={100}
                                        paginationSize={3}
                                        columns={columnStudentFiles}
                                        keyField="_id"
                                        noDataFoundLabel={t("ExaminationAccessFiles.NoStudentFilesFound")}
                                        id={this.tableId[1]}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                </Container>
            </>
        );
    }
}

export default withTranslation()(ExaminationAccessFiles);